import { object, ValidationError } from '@calendly/form/validation'
import { httpRequest } from '@calendly/http-tools'

const convertOwnerParams = ({ id, type }) => {
  switch (type) {
    case 'user': return {
      user_id: id,
      owner_type: type
    }
    case 'page': case 'team': return {
      team_id: id,
      owner_type: type
    }
    case 'user_group': return {
      user_group_id: id,
      owner_type: type
    }
    case 'organization': return {
      owner_type: type
    }
    default: return {}
  }
}

const multipleErrorsFromResponse = ({ payload }, { getValue }) => (
  {
    message: () => (
      Object.entries(payload).map(
        ([path, [message]]) => new ValidationError(
          message,
          getValue(path),
          path
        )
      )
    )
  }
)

export const buildActionValidationSchema = ({
  owner,
  frontendValidationSchema,
  buildConfiguration
}) => (
  object().test('validateConfiguration', '', async (formFields, { createError }) => {
    try {
      await frontendValidationSchema.validate(formFields, { abortEarly: false })

      const configuration = buildConfiguration(formFields)
      const [success, response] = await httpRequest({
        url: '/api/workflows/workflow_actions/validate',
        method: 'POST',
        data: {
          ...configuration,
          ...convertOwnerParams(owner)
        }
      })

      if (success) { return true }

      return createError(
        multipleErrorsFromResponse(
          response, {
            getValue: (key) => configuration[key]
          }
        )
      )
    } catch (error) {
      return error
    }
  })
)
